import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { v4 as uuidv4 } from 'uuid';

interface ComponentMeta {
  title: string;
  subtitle: string;
}

const COMPONENT_META: Record<ShopPlugin.ProductPagePromise.LayoutComponentType, ComponentMeta> = {
  [ShopPlugin.ProductPagePromise.LayoutComponentType.LABEL]: {
    title: 'Label',
    subtitle: 'Free text + icon',
  },
  [ShopPlugin.ProductPagePromise.LayoutComponentType.DELIVERY_DATE]: {
    title: 'Delivery date',
    subtitle: 'Estimated arrival date - required',
  },
  [ShopPlugin.ProductPagePromise.LayoutComponentType.SHIPPING_METHOD_LINE]: {
    title: 'Shipping method line',
    subtitle: 'Method name, price data, "change" dropdown',
  },
  [ShopPlugin.ProductPagePromise.LayoutComponentType.LOCATION_INPUT]: {
    title: 'Location input',
    subtitle: 'Zip code or full address entry for personalized delivery promise',
  },
  [ShopPlugin.ProductPagePromise.LayoutComponentType.LINE_SEPARATOR]: {
    title: 'Line separator',
    subtitle: 'A horizontal divider line between components',
  },
  [ShopPlugin.ProductPagePromise.LayoutComponentType.CUTOFF_TIMER]: {
    title: 'Order cutoff timer',
    subtitle: 'Urgency countdown for same/next-day shipping',
  },
  [ShopPlugin.ProductPagePromise.LayoutComponentType.TRUST_SIGNALS]: {
    title: 'Trust signals',
    subtitle: 'Custom checkmark rows (free returns, warehouse info, etc.)',
  },
};

@Component({
  selector: 'product-page-configurations-advanced-tab',
  templateUrl: './product-page-configurations-advanced-tab.component.html',
  styleUrls: ['./product-page-configurations-advanced-tab.component.scss'],
  standalone: false,
})
export class ProductPageConfigurationsAdvancedTabComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;

  components: UntypedFormArray;
  componentMeta = COMPONENT_META;
  LayoutComponentType = ShopPlugin.ProductPagePromise.LayoutComponentType;
  expandedId: string | null = null;

  ngOnInit(): void {
    this.components = this.formGroup.get('advancedLayoutSettings.components') as UntypedFormArray;
  }

  onDrop(event: CdkDragDrop<unknown>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    const control = this.components.at(event.previousIndex);
    this.components.removeAt(event.previousIndex);
    this.components.insert(event.currentIndex, control);
    this.components.markAsDirty();
  }

  toggleExpanded(id: string): void {
    this.expandedId = this.expandedId === id ? null : id;
  }

  addLineSeparator(): void {
    const separatorForm = new UntypedFormGroup({
      id: new UntypedFormControl(uuidv4()),
      type: new UntypedFormControl(ShopPlugin.ProductPagePromise.LayoutComponentType.LINE_SEPARATOR),
      enabled: new UntypedFormControl(true),
      options: new UntypedFormGroup({}),
    });
    this.components.push(separatorForm);
    this.components.markAsDirty();
  }

  removeComponent(index: number): void {
    this.components.removeAt(index);
    this.components.markAsDirty();
  }
}
